import { Controller } from "@hotwired/stimulus";

export default class CsvUploadController extends Controller {
  static targets = ["fileInput", "validationButton", "loading", "submitButton"];

  declare readonly fileInputTarget: HTMLInputElement;
  declare readonly validationButtonTarget: HTMLButtonElement;
  declare readonly loadingTarget: HTMLElement;
  declare readonly submitButtonTarget: HTMLButtonElement;

  private readonly ENABLED_CLASSES = ["cursor-pointer", "bg-[#14126F]", "hover:bg-[#0f0e57]", "transition-colors"];
  private readonly DISABLED_CLASSES = ["cursor-not-allowed", "bg-[#9E9DA7]"];

  openFileDialog(): void {
    this.fileInputTarget.click();
  }

  handleFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      this.validationButtonTarget.click();
    }
  }

  showLoading(): void {
    this.loadingTarget.classList.remove("hidden");
  }

  handleFrameRender(event: CustomEvent): void {
    const frame = event.target as HTMLElement;
    const hasSuccess = frame.querySelector('[data-validation-status="success"]');

    if (hasSuccess) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.type = "submit";
      this.submitButtonTarget.classList.remove(...this.DISABLED_CLASSES);
      this.submitButtonTarget.classList.add(...this.ENABLED_CLASSES);
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.type = "button";
      this.submitButtonTarget.classList.remove(...this.ENABLED_CLASSES);
      this.submitButtonTarget.classList.add(...this.DISABLED_CLASSES);
    }
  }
}
